import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { observer } from 'mobx-react';
import { CircularProgress, adaptV4Theme } from '@mui/material';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import { green, red } from '@mui/material/colors';
 
import FlowStore from './FlowStore';
import Dashboard from './Dashboard';
import Review from './Review';
import GenerateDocuments from './GenerateDocuments';
import FlowAdmin from './FlowAdmin';
import TemplateAdmin from './TemplateAdmin';
import { Error } from './Error';
//import { onMessageListener } from './firebase';

//const hydrate = create({
//  storage: localStorage,
//  jsonify: true
//});

export const store = new FlowStore();
store.init();
//window.store = store;

// hydrate('ptoflow', store).then(() => {
//   console.log('Recovered store');
//   // Sync the server to the current attorney
//   if (store.isAttorneySelected())
//     store.setAttorney(store.attorney);
//   store.isLoaded = true;
// });


const theme = createTheme(adaptV4Theme({
  palette: {
    primary: { main: green[800] }, 
    secondary: { main: red[800] },
  },
  typography: { fontSize: 14 },
  props: {
    MuiTextField: {
      variant: 'outlined',
      margin: 'dense',
      size: 'small',
    },
  },
  overrides: {
    //MuiButton: {
    //  root: { color: 'pink' },
    //},
    MuiInputLabel: {
      root: {
       //fontSize: 40,
        color: 'blue',
        //'&.hover': { backgroundColor: 'purple' },
      },
      shrink: {
        color: 'black',
      }
    },
  }
}));

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

/*
const Notification = () => {
  const [notification, setNotification] = React.useState({title: '', body: ''});
  const notify = () =>  console.log(notification);

  // useEffect(() => {
  //   if (notification?.title ){
  //    notify()
  //   }
  // }, [notification])

  onMessageListener()
    .then((payload) => {
      console.log('notifiation ', payload);
      //setNotification({title: payload?.notification?.title, body: payload?.notification?.body});     
    })
    .catch((err) => console.log('failed: ', err));

  return ( null );

}
*/

const App = observer((props) => {
  console.log('Constructing the App');

  try {
    let currentLocation = window.location.href + '';
    console.log('Rendering app: ', currentLocation, store.isLoaded, store.haveUser());
    if (!store.isLoaded || !store.haveUser()) {
      return (
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '5em'}}>
          <CircularProgress />
        </div>);
    }
    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          {/* <Notification /> */}
          <BrowserRouter >
            <Routes>
              <Route exact path="/dashboard"
                     element={<Dashboard store={store} refresh={false}/>}
              />
              <Route exact path="/refresh"
                     element={<Dashboard store={store} refresh={true} />}
              />
              <Route path="/review"
                     element={<Review store={store}/>}
              />
              <Route path="/genDocs"
                     element={<GenerateDocuments store={store} />}
              />
              <Route path="/admin/*"
                     element={<FlowAdmin store={store} theme={theme} />}
              />
              <Route path="/templates"
                     element={<TemplateAdmin store={store} />}
              />
            </Routes> 
          </BrowserRouter>
          </ThemeProvider>
      </StyledEngineProvider>
    );
  }
  catch (e) {
    console.log('Caught error in App.render', e);
    return (
      <div>
        <Error msg='Error while rendering App'
               error={e}
               store={store}/>
      </div>
    );
  }
});
                    
export default App;
